export const iconFontAwesomeConstructionToiletsPortable = (
	<i className="fa-solid fa-toilets-portable"></i>
);
